import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import InversionesInfo from "@components/InversionesInfo/InversionesInfo";
import { history } from "@helpers/history";
import { isObjEmpty } from "@helpers/utils";

const BORDER_TOP_COLOR = "#d7de00";

function Inversiones(props) {
  const {
    match: { params },
  } = props;
  const [idInversion, setIdInversion] = useState("");
  const [inversion, setInversion] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { inversiones } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    setIdInversion(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const defRoute = rutas?.filter((route) => route?.name === "Inversiones");

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url.replace("/:id", ""),
        text: route.h1,
      };
    });
    if (!isEmpty(idInversion) && !isEmpty(inversiones)) {
      let promise = new Promise((resolve, reject) => {
        let normalizeInversion = [];
        let resMatch = {};
        if (!isEmpty(inversiones?.aCInversion)) {
          normalizeInversion = inversiones.aCInversion.map((inv) => ({
            ...inv,
            idInversion: inv.idInversion.toLowerCase().replaceAll(" ", "-"),
            rutaPrevia: prevRoute,
          }));
          resMatch =
            normalizeInversion &&
            normalizeInversion.filter(
              (inv) => inv.idInversion === idInversion
            )[0];
        }
        resolve(resMatch);
      });

      promise.then((res) => {
        !isEmpty(res) ?
          setInversion({
            title: res.titulo,
            description: res.descripcion?.html,
            details: res.bag?.contentItems,
            files: res.archivos?.contentItems,
            prevRoute: res.rutaPrevia,
          })
        : isObjEmpty(inversion) && history.push('/no-encontrado')  
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inversiones, idInversion]);

  return (
    <>
      {!isEmpty(idInversion) && !isEmpty(inversion) && (
        <InversionesInfo
          inversion={inversion}
          borderTopColor={BORDER_TOP_COLOR}
        />
      )}
    </>
  );
}

export default Inversiones;
